import { Component,Input,Output, EventEmitter } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Globals } from "projects/shared/models/Globals";

declare var $: any;

@Component({
  selector: "info-box-popup",
  templateUrl: "./info-box-popup.component.html",
  styles: []
})

export class InfoBoxPopupComponent {
   globals;
  
   _pinInfo; 
  get pinInfo(): any { 
    return this._pinInfo;
  }
  @Input()
  set pinInfo(val: any) {
    this._pinInfo = val;
  }

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.globals=Globals;

    $('#myModal').on('shown.bs.modal', function (e) {
			$("audio").not($(".audioplayer audio")).audioPlayer();
			$(".audioplayer audio").show();
		});


    var self=this;
    $('#myModal').on('hidden.bs.modal', function () {

      $('#myModal .tab-pane').removeClass('show active');
      $($('#myModal .tab-pane')[0]).addClass('show active');
      $('#myModal .nav-item').removeClass('active');
      $($('#myModal .nav-item')[0]).addClass('active');   

      self.resetMedia();
    });
  }

  runMedia(item){
    this.resetMedia()

    if (item.MediaType == 'videoYoutube') {
      item.EmbededLink=this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + item.ExternalLink.split('v=')[1] + "?controls=1")
    }

    if(!$('.mediaAudio .audioplayer')[0]){
      $('.mediaAudio audio').audioPlayer();      
    }

  }

  resetMedia() {
		var sounds = document.getElementsByTagName('audio');
		for (var i = 0; i < sounds.length; i++) sounds[i].pause();
	
		var videos = document.getElementsByTagName('video');
		for (var i = 0; i < videos.length; i++) videos[i].pause();
	
		var videosYoutube=$('.youtube-video');
		var videosLength=videosYoutube.length;
		if(videosLength && videosLength>0){			
			for(var i=0;i<videosLength;i++){
				videosYoutube[i].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*'); 
			}
		}
	}

  getAbsoluteUrl(url){
    return window.location.origin +url;
  }

}
